document.addEventListener('DOMContentLoaded', function() {
  const globalModal = document.getElementById('GlobalQuickAddModal');
  if (!globalModal) return;

  // 1. AJAX 加载弹窗
  document.body.addEventListener('click', async function(e) {
    // 🎯 屏蔽阻断：旧快速加购弹窗已被全新的 custom-quick-shop 接管，直接拦截退出
    return;
    const btn = e.target.closest('.custom-quick-add-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const productUrl = btn.getAttribute('data-product-url');
      if (!productUrl) return;

      btn.classList.add('is-loading');

      try {
        const response = await fetch(`${productUrl.split('?')[0]}?section_id=quick-add-ajax`);
        const text = await response.text();
        globalModal.innerHTML = text;
        globalModal.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        // Parse UTM from data-product-url and store recommend_source on modal
        (function() {
          const dataUrl = btn.getAttribute('data-product-url');
          if (dataUrl && dataUrl.includes('?')) {
            try {
              const urlParams = new URLSearchParams(dataUrl.split('?')[1]);
              if (urlParams.get('utm_campaign') === 'product_recommend') {
                globalModal.setAttribute('data-recommend-source', 'sr_bubble');
                var rsInput = globalModal.querySelector('#MzgQaRecommendSource');
                if (rsInput) rsInput.value = 'sr_bubble';
              }
            } catch(e) {}
          }
        })(); 

        if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();

        // 默认款式初始化 (加标识位，防止开屏自动跳图)
        setTimeout(() => {
          const checked = globalModal.querySelector('.mzg-qa-variant-input:checked');
          if (checked) checked.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { isInitial: true } }));
        }, 50);

        // GA4 view_item for quick-add modal
        setTimeout(() => {
          if (typeof gtag !== 'function') return;
          try {
            const currency = (window.theme && window.theme.settings && window.theme.settings.currency_code) ||
                             (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
            const recommendSource = globalModal.getAttribute('data-recommend-source') || 'direct';
            const productTitle = globalModal.querySelector('.mzg-qa-product-title');
            const titleText = productTitle ? productTitle.textContent.trim() : '';
            const variantsScript = globalModal.querySelector('#MzgQaProductJson');
            if (!variantsScript) return;
            const variants = JSON.parse(variantsScript.textContent);
            const form = globalModal.querySelector('#MzgQaForm');
            const selected = Array.from(form.querySelectorAll('.mzg-qa-variant-input:checked')).map(function(r) { return r.value; });
            const matched = variants.find(function(v) { return selected.every(function(val, i) { return v.options[i] === val; }); });
            if (matched) {
              var gaViewItems = [{
                item_id: matched.sku || matched.id.toString(),
                item_name: titleText,
                price: matched.price / 100
              }];

              gtag('event', 'view_item', {
                currency: currency,
                value: matched.price / 100,
                items: gaViewItems,
                recommend_source: recommendSource
              });

              gtag('event', 'select_item', {
                currency: currency,
                items: gaViewItems,
                item_list_name: recommendSource === 'sr_bubble' ? 'sr_bubble' : 'product_card',
                recommend_source: recommendSource
              });
            }
          } catch(e) {}
        }, 200);

        // GA4 begin_checkout tracking for dynamic checkout button
        setTimeout(() => {
          var dcContainer = globalModal.querySelector('.mzg-qa-dynamic-checkout');
          if (dcContainer && !dcContainer.hasAttribute('data-ga4-tracked')) {
            dcContainer.setAttribute('data-ga4-tracked', 'true');
            dcContainer.addEventListener('click', function(e) {
              if (!e.target.closest('button, a, input[type="submit"], input[type="image"]')) return;
              if (typeof gtag !== 'function') return;
              try {
                var currency = (window.theme && window.theme.settings && window.theme.settings.currency_code) ||
                               (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
                var recommendSource = globalModal.getAttribute('data-recommend-source') || 'direct';
                var form = globalModal.querySelector('#MzgQaForm');
                var qtyInput = form.querySelector('#MzgQaQuantity');
                var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
                var variantsScript = form.querySelector('#MzgQaProductJson');
                var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
                var selected = Array.from(form.querySelectorAll('.mzg-qa-variant-input:checked')).map(function(r) { return r.value; });
                var matched = variants.find(function(v) { return selected.every(function(val, i) { return v.options[i] === val; }); });
                var productTitle = globalModal.querySelector('.mzg-qa-product-title');
                var titleText = productTitle ? productTitle.textContent.trim() : '';
                var price = matched ? matched.price / 100 : 0;

                gtag('event', 'begin_checkout', {
                  currency: currency,
                  value: price * quantity,
                  items: [{
                    item_id: matched ? (matched.sku || matched.id.toString()) : '',
                    item_name: titleText,
                    price: price,
                    quantity: quantity
                  }],
                  recommend_source: recommendSource
                });
              } catch(e) {}
            });
          }
        }, 500);
      } catch (error) {
        window.location.href = productUrl; 
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  });

  // 2. 关闭逻辑
  document.body.addEventListener('click', e => {
    if (e.target.closest('[data-modal-close]')) {
      globalModal.classList.add('is-closing');
      setTimeout(() => {
        globalModal.classList.remove('is-open', 'is-closing');
        document.body.style.overflow = '';
        globalModal.innerHTML = '';
      }, 350);
    }
  });

  // 3. 点击缩略图切换 (含计数器更新)
  document.body.addEventListener('click', e => {
    const thumb = e.target.closest('.mzg-qa-thumb-item');
    if (thumb) {
      const targetId = thumb.getAttribute('data-target-id');
      const index = thumb.getAttribute('data-index');
      const container = thumb.closest('.mzg-qa-left');
      
      container.querySelectorAll('.mzg-qa-thumb-item').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      container.querySelectorAll('.product-single__media').forEach(media => {
        media.classList.remove('is-active');
        const v = media.querySelector('video'); if(v) v.pause();
        const f = media.querySelector('iframe'); if(f) { const s = f.src; f.src = s; }
        if (media.getAttribute('data-media-id') === targetId) media.classList.add('is-active');
      });

      const countDisplay = container.querySelector('#MzgQaCurrentIndex');
      if (countDisplay && index) countDisplay.textContent = index;
      
      thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  });

  // 4. 变体切换 (对齐 PDP 匹配规则)
  document.body.addEventListener('change', e => {
    if (e.target.matches('.mzg-qa-variant-input')) {
      const form = e.target.closest('#MzgQaForm');
      const group = e.target.closest('.mzg-qa-variant-group');
      const label = group.querySelector('.mzg-qa-variant-label');
      const optionName = label ? label.textContent.split(':')[0].toLowerCase().trim() : '';

      // 只有当选项名包含 color/颜色/colour 时才切换图片
      const isColorOption = optionName.includes('color') || optionName.includes('颜色') || optionName.includes('colour');
      if (group.querySelector('.mzg-qa-selected-value')) group.querySelector('.mzg-qa-selected-value').textContent = e.target.value;

      const variants = JSON.parse(form.querySelector('#MzgQaProductJson').textContent);
      const selected = Array.from(form.querySelectorAll('.mzg-qa-variant-input:checked')).map(r => r.value);
      const matched = variants.find(v => selected.every((val, i) => v.options[i] === val));

      if (matched) {
        form.querySelector('#MzgQaVariantId').value = matched.id;
        
        // 价格更新
        const priceDiv = form.closest('.mzg-qa-content').querySelector('#MzgQaPrice');
        if (priceDiv && window.Shopify && Shopify.formatMoney) {
            const formatted = Shopify.formatMoney(matched.price, window.money_format || "${{amount}}");
            priceDiv.querySelectorAll('.price-item--regular, .price-item--sale').forEach(el => el.textContent = formatted);
        }

        // 按钮更新
        // --- 预售判定与按钮/快捷支付更新 START ---
        const btn = form.querySelector('#MzgQaAddToCartBtn');
        const paymentContainer = form.querySelector('.mzg-qa-dynamic-checkout');
        
        let isPreorder = false;
        
        // ⭐ 新增：从表单属性中读取商品级的 pre-order 标签状态
        const hasProductPreorderTag = form.getAttribute('data-has-preorder-tag') === 'true';

        // 获取预埋在 form 里的变体预售 JSON 数据
        // const preorderDataElement = form.querySelector('script[id^="preorder-data-"]');
        // if (preorderDataElement && matched) {
        //     try {
        //         const preorderData = JSON.parse(preorderDataElement.textContent);
        //         const currentVariantData = preorderData[matched.id];
                
        //         // ⭐ 核心逻辑：满足商品级标签，或者满足变体级 Metafield 设置，都判定为预售
        //         if (hasProductPreorderTag || (currentVariantData && currentVariantData.is_preorder && currentVariantData.inventory > 0)) {
        //             isPreorder = true;
        //         }
        //     } catch (e) {
        //         console.error("解析预售数据失败", e);
        //     }
        // } else if (hasProductPreorderTag) {
        //     // 兜底：即使解析不到变体脚本，只要商品打上了标签就是预售
        //     isPreorder = true;
        // }

        // 根据最新状态更新 DOM
        if (!matched.available) {
            // 状态一：已售罄 (Sold Out) - 优先级最高
            btn.textContent = 'SOLD OUT';
            btn.disabled = true;
            if (paymentContainer) paymentContainer.style.display = 'none'; 

        } else {
            // 状态二：有库存可购买
            btn.disabled = false;
            // if (isPreorder) {
            //     // 预购商品
            //     btn.textContent = window.variantStrings?.preOrder || 'Pre-order';
            //     if (paymentContainer) paymentContainer.style.display = 'none'; // 预购强制隐藏快捷支付
            // } else {
                // 普通现货
                btn.textContent = 'ADD TO BAG';
                if (paymentContainer) paymentContainer.style.display = '';     // 现货恢复显示快捷支付
            // }
        }
        // --- 预售判定与按钮/快捷支付更新 END ---
        // 图片联动
        if (matched.featured_media && isColorOption && (!e.detail || !e.detail.isInitial)) {
          const mediaId = matched.featured_media.id.toString();
          const colorHandle = matched.options[0].toLowerCase().replace(/\s+/g, '-');
          const targetThumb = form.closest('.mzg-qa-content').querySelector(`.mzg-qa-thumb-item[data-target-id="${mediaId}"]`) || 
                              form.closest('.mzg-qa-content').querySelector(`.mzg-qa-thumb-item[data-target-id="color-${colorHandle}"]`);
          if (targetThumb) targetThumb.click();
        }
      }
    }
  });

  // 5. 数量与提交逻辑 (恢复购物车抽屉无刷新更新)
  document.body.addEventListener('click', e => {
    const qtyBtn = e.target.closest('.mzg-qa-qty-btn');
    if (qtyBtn) {
      const input = qtyBtn.closest('.mzg-qa-qty-picker').querySelector('input');
      let val = parseInt(input.value);
      input.value = qtyBtn.classList.contains('plus') ? val + 1 : (val > 1 ? val - 1 : 1);
    }
  });

  document.body.addEventListener('submit', async e => {
    const form = e.target.closest('#MzgQaForm');
    if (form) {
      e.preventDefault();
      const btn = form.querySelector('#MzgQaAddToCartBtn');
      if (btn.disabled) return;
      btn.textContent = 'ADDING...'; btn.disabled = true;
      try {
        const rootUrl = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
        const response = await fetch(rootUrl + 'cart/add.js', { method: 'POST', body: new FormData(form) });
        const data = await response.json();
        if (data.status && data.status !== 200) {
          alert(data.description); 
          btn.textContent = 'ERROR';
          btn.disabled = false;
        } else {    
          // 更新顶部购物车数字
          fetch(rootUrl + 'cart.js').then(r=>r.json()).then(c=>{
            document.querySelectorAll('.cart-count-bubble span, .cart-item-count, .cart-count').forEach(el => el.textContent = c.item_count);
          });

          // GA4 add_to_cart + select_item with recommend_source tracking
          if (typeof gtag === 'function') {
            try {
              const currency = (window.theme && window.theme.settings && window.theme.settings.currency_code) ||
                               (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
              const recommendSource = globalModal.getAttribute('data-recommend-source') || 'direct';
              const qtyInput = form.querySelector('#MzgQaQuantity');
              const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
              const variantIdInput = form.querySelector('#MzgQaVariantId');
              const variantId = variantIdInput ? variantIdInput.value : '';
              const variantsScript = form.querySelector('#MzgQaProductJson');
              const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
              const selected = Array.from(form.querySelectorAll('.mzg-qa-variant-input:checked')).map(function(r) { return r.value; });
              const matched = variants.find(function(v) { return selected.every(function(val, i) { return v.options[i] === val; }); });
              const productTitle = globalModal.querySelector('.mzg-qa-product-title');
              const titleText = productTitle ? productTitle.textContent.trim() : '';
              const price = matched ? matched.price / 100 : 0;

              var gaItems = [{
                item_id: matched ? (matched.sku || matched.id.toString()) : variantId,
                item_name: titleText,
                price: price,
                quantity: quantity
              }];

              gtag('event', 'add_to_cart', {
                currency: currency,
                value: price * quantity,
                items: gaItems,
                recommend_source: recommendSource
              });
            } catch(e) {}
          }

          // ⭐ 核心修复：更新侧边抽屉购物车的内容 ⭐
          if (typeof $ !== 'undefined') {
            const $cartDropdown = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
            if ($cartDropdown.length > 0) {
                $.get(rootUrl + 'cart?view=ajax_side_cart', function(htmlData) {
                    $cartDropdown.html(htmlData);
                    // 触发免费包邮进度条等依赖此事件的组件更新
                    document.querySelectorAll('[data-free-shipping-wrapper]').forEach(wrapper => {
                        wrapper.dispatchEvent(new Event('change', { bubbles: true }));
                    });
                });
            }
          }

          // // 恢复原有的成功提示框交互
          // if (window.halo && typeof window.halo.showWarning === 'function') {
          //   window.halo.showWarning('Item added to cart successfully!');
          // }

          // 自动关闭弹窗
          setTimeout(() => {
            globalModal.classList.add('is-closing');
            setTimeout(() => { 
              globalModal.classList.remove('is-open', 'is-closing'); 
              globalModal.innerHTML=''; 
              document.body.style.overflow=''; 
              // 打开购物车侧边栏
              document.body.classList.add('cart-sidebar-show');
              btn.textContent = 'ADDED TO BAG';
            }, 350);
          }, 1000);
        }
      } catch (err) { 
        console.error('Add to cart failed:', err);
        btn.disabled = false; 
        btn.textContent = 'ERROR'; 
      }
    }
  });
});